/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {message, Icon} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Loader from '../loaders/loader'
import AutoComplete from '../BaseComponent/autocomplete'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import moment from 'moment'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

class DriverCommissionReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [],
      comboProvides: [],
      printInfo: [],
      lengthItems: 0,
      pageNumber: 1,
      fromDate: moment(),
      toDate: moment(),
      Drivers: [],
      driverId: null
    }
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      items: data
    })
  }

  changeDropDown(data) {
    this.setState({
      items: data,
      lengthItems: sessionStorage.getItem('countAll')
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  filter() {
    const {fromDate, toDate} = this.state
    const driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId

    if (!fromDate) {
      message.error('تاریخ از الزامی است')
      return
    }

    if (!toDate) {
      message.error('تاریخ تا الزامی است')
      return
    }

    sessionStorage.setItem(
      'params',
      `&fromTime=${this.epochFrom(fromDate)}&toTime=${this.epochTo(toDate)}&driverId=${driverId}`
    )
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_DRIVER_POURCENTAGE
        }?export=false&pageSize=10&pageNumber=1&&fromTime=${this.epochFrom(fromDate)}&toTime=${this.epochTo(
          toDate
        )}&driverId=${driverId}`,
        {}
      )
      .then((response) => {
        console.log(response)
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          $('.showBaseTable').fadeIn()

          this.setState({
            items: response.data.object.result,
            lengthItems: response.data.object.countAll
          })
        } else {
          this.setState({
            loading: false
          })
          $('.showBaseTable').fadeOut()
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
  }

  exportExcel = () => {
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_DRIVER_POURCENTAGE
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result.map((item) => {
              return {
                ...item,
                planDate: item.planDate ? jMoment(item.planDate).format('jYYYY/jM/jD') : '-',
                mobile: item.mobile ? item.mobile.replace(/\+98/g, '0') : '-'
              }
            }),
            loading: false
          })

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_DRIVER_POURCENTAGE}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        console.log(response)

        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo().then(() => {
      window.print()
    })
  }

  handleFromDateChange = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleToDateChange = (toDate) => {
    this.setState({
      toDate
    })
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let excelColumns = [
      {title: 'تاریخ تحویل', value: 'planDate'},
      {title: 'خریدار', value: 'buyerName'},
      {title: 'کد مشتری', value: 'userId'},
      {title: 'موبایل', value: 'mobile'},
      {title: 'رساننده', value: 'driverName'},
      {title: 'کد رساننده', value: 'driverId'},
      {title: 'منطقه', value: 'districtName'},
      {title: 'تعداد', value: 'countt'},
      {title: 'مقدار', value: 'quantity'}
    ]
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'تاریخ تحویل',
      'خریدار',
      'کد مشتری',
      'موبایل',
      'رساننده',
      'کد رساننده',
      'منطقه',
      'تعداد',
      'مقدار'
    ]
    let urlParams = sessionStorage.getItem('params')

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست پورسانت راننده"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.planDate ? jMoment(item.planDate).format('jYYYY/jM/jD') : '-'}</td>
                  <td>{item.buyerName}</td>
                  <td>{item.userId}</td>
                  <td>{item.mobile ? item.mobile.replace(/\+98/g, '0') : '-'}</td>
                  <td>{item.driverName}</td>
                  <td>{item.driverId}</td>
                  <td>{item.districtName}</td>
                  <td>{item.countt}</td>
                  <td>{item.quantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست پورسانت راننده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'buyerName'}
                field={'buyerName'}
                title={'خریدار'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'userId'}
                field={'userId'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'mobile'}
                field={'mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driverName'}
                field={'driverName'}
                title={'رساننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driverId'}
                field={'driverId'}
                title={'کد رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'districtName'}
                field={'districtName'}
                title={'منطقه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'countt'}
                field={'countt'}
                title={'تعداد'}
                width="70px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'quantity'}
                field={'quantity'}
                title={'مقدار'}
                width="70px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>گزارش پورسانت راننده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl="print"
                  url={REPORT_RETAIL.REPORT_RETAIL_DRIVER_POURCENTAGE}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_RETAIL.REPORT_RETAIL_DRIVER_POURCENTAGE + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel} disabled={!this.state.items.length}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint} disabled={!this.state.items.length}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label className="font-weight-bold">
                    تاریخ از :<span className="requireFiled font-weight-bold">*</span>
                  </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      inline
                      okLabel="تأیید"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      cancelLabel="لغو"
                      labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                      value={this.state.fromDate}
                      id="from-date"
                      onChange={this.handleFromDateChange}
                      TextFieldComponent={this.date}
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold">
                    تاریخ تا :<span className="requireFiled font-weight-bold">*</span>
                  </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      inline
                      okLabel="تأیید"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      cancelLabel="لغو"
                      labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                      value={this.state.toDate}
                      id="to-date"
                      onChange={this.handleToDateChange}
                      TextFieldComponent={this.date}
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>تاریخ تحویل</td>
                    <td>خریدار</td>
                    <td>کد مشتری</td>
                    <td>موبایل</td>
                    <td>رساننده</td>
                    <td>کد رساننده</td>
                    <td>منطقه</td>
                    <td>تعداد</td>
                    <td>مقدار</td>
                  </tr>
                  {this.state.items.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{item.planDate ? jMoment(item.planDate).format('jYYYY/jM/jD') : '-'}</td>
                      <td>{item.buyerName}</td>
                      <td>
                        <Link target="_blank" to={`/base/users/persina/${item.userId}`}>
                          {item.userId}
                        </Link>
                      </td>
                      <td>{item.mobile ? item.mobile.replace(/\+98/g, '0') : '-'}</td>
                      <td>{item.driverName}</td>
                      <td>{item.driverId}</td>
                      <td>{item.districtName}</td>
                      <td>{item.countt}</td>
                      <td>{item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthItems}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_RETAIL.REPORT_RETAIL_DRIVER_POURCENTAGE}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DriverCommissionReport
